import { useAPPTranslation } from '~/i18n/useAPPTranslation'
import { Flex, Text } from '@vtex/shoreline'
import { useScreens } from './hooks/useScreens'
import { ScreensProps } from './types'

import clsx from 'clsx'

import s from '../styles.module.css'

export function Screens(props: ScreensProps) {
  const { t } = useAPPTranslation()
  const { elements } = useScreens(props)

  return (
    <Flex
      direction="column"
      gap="var(--sl-space-8)"
      className={s.modalScreensContainer}
    >
      <Flex justify="space-between" align="center">
        <Text variant="emphasis">{elements?.title || null}</Text>
        <Text variant="body" className={clsx(s.textSoft, s.textEnd)}>
          {t('rm:campaign.create.ScreenGroups.Modal.screens.description')}
        </Text>
      </Flex>

      {elements?.component || null}
    </Flex>
  )
}
